import { render, staticRenderFns } from "./OracleSendReceiptSuccess.vue?vue&type=template&id=b4874460&scoped=true"
import script from "./OracleSendReceiptSuccess.vue?vue&type=script&lang=js"
export * from "./OracleSendReceiptSuccess.vue?vue&type=script&lang=js"
import style0 from "./OracleSendReceiptSuccess.vue?vue&type=style&index=0&id=b4874460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4874460",
  null
  
)

export default component.exports